import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_6: FaireProductEntity = {
  token: "sweet-wink-6",
  type: "product",
  name: "Sweet Wink Gold Bottom Hangers - 12 Pack - Children's Hanger",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/28d703a93dafba2b5ed868f72b752b7feece312bddcbd4fdc8e6acfc5b659fee.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 12,
  msrpDollars: 24,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
